export const CONTACT = {
  roadsideLabel: "+39 3517523353",
  roadsideHref: "tel:+393517523353",
  roadsideWhatsAppNumber: "393517523353",
  workshopLabel: "+39 3517729543",
  workshopHref: "tel:+393517729543",
  workshopWhatsAppNumber: "393517729543"
};

export const getWhatsAppUrl = (_message = "", phoneNumber = CONTACT.roadsideWhatsAppNumber) =>
`https://wa.me/${phoneNumber}`;

export const PHOTO_EDITOR_PATH = "/gestione-foto";
export const BRAND_HOME_PATH = "/viscar-soccorso-stradale-h24";
export const WORKSHOP_PAGE_PATHS = ["/meccatronica", "/gommista"];
export const isWorkshopPagePath = (pathname = "") => WORKSHOP_PAGE_PATHS.includes(pathname);

export const DEFAULT_WHATSAPP_MESSAGE =
"Salve Viscar, ho bisogno di soccorso stradale H24. Mi trovo a: ";

export const DEFAULT_IMAGE_SLOTS = {
  hero: "",
  lightDuty: "",
  lightDutyAlt1: "",
  lightDutyAlt2: "",
  heavy: "",
  heavyAlt1: "",
  heavyAlt2: "",
  complex: "",
  complexAlt1: "",
  complexAlt2: "",
  mobileWorkshop: "",
  mobileWorkshopAlt1: "",
  mobileWorkshopAlt2: "",
  fleetTow: "",
  fleetCrane: "",
  fleetTruck: "",
  fleetMobile: "",
  meccatronicaHero: "",
  meccatronicaDetail: "",
  meccatronicaDetailAlt1: "",
  meccatronicaDetailAlt2: "",
  meccatronicaSupport: "",
  meccatronicaSupportAlt1: "",
  meccatronicaSupportAlt2: "",
  gommistaHero: "",
  gommistaDetail: "",
  gommistaDetailAlt1: "",
  gommistaDetailAlt2: "",
  gommistaSupport: "",
  gommistaSupportAlt1: "",
  gommistaSupportAlt2: ""
};

export const PHOTO_SLOT_DEFINITIONS = [
{ key: "hero", label: "Hero principale", description: "Immagine hero della pagina Soccorso H24.", section: "Hero", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "lightDuty", label: "Soccorso leggero · Immagine 1", description: "Prima immagine della rotazione soccorso leggero.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "lightDutyAlt1", label: "Soccorso leggero · Immagine 2", description: "Seconda immagine della rotazione soccorso leggero.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "lightDutyAlt2", label: "Soccorso leggero · Immagine 3", description: "Terza immagine della rotazione soccorso leggero.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "heavy", label: "Soccorso pesante · Immagine 1", description: "Prima immagine della rotazione mezzi pesanti.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "heavyAlt1", label: "Soccorso pesante · Immagine 2", description: "Seconda immagine della rotazione mezzi pesanti.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "heavyAlt2", label: "Soccorso pesante · Immagine 3", description: "Terza immagine della rotazione mezzi pesanti.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "mobileWorkshop", label: "Officina mobile · Immagine 1", description: "Prima immagine della rotazione officina mobile.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "mobileWorkshopAlt1", label: "Officina mobile · Immagine 2", description: "Seconda immagine della rotazione officina mobile.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "mobileWorkshopAlt2", label: "Officina mobile · Immagine 3", description: "Terza immagine della rotazione officina mobile.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "complex", label: "Recuperi complessi · Immagine 1", description: "Prima immagine della rotazione recuperi complessi.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "complexAlt1", label: "Recuperi complessi · Immagine 2", description: "Seconda immagine della rotazione recuperi complessi.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "complexAlt2", label: "Recuperi complessi · Immagine 3", description: "Terza immagine della rotazione recuperi complessi.", section: "Sezioni operative", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "fleetCrane", label: "Flotta gru", description: "Primo mezzo flotta, recuperi pesanti.", section: "Flotta", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "fleetTow", label: "Flotta traino rapido", description: "Secondo mezzo flotta, soccorso leggero.", section: "Flotta", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "fleetTruck", label: "Flotta supporto medio", description: "Terzo mezzo flotta, supporto strada e autostrada.", section: "Flotta", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "fleetMobile", label: "Flotta assistenza tecnica", description: "Quarto mezzo flotta, officina mobile.", section: "Flotta", page: "Soccorso H24", pageKey: "soccorso-h24" },
{ key: "meccatronicaHero", label: "Hero Meccatronica", description: "Hero principale della pagina Meccatronica.", section: "Hero", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaDetail", label: "Struttura tecnica · Immagine 1", description: "Prima immagine della rotazione struttura tecnica Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaDetailAlt1", label: "Struttura tecnica · Immagine 2", description: "Seconda immagine della rotazione struttura tecnica Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaDetailAlt2", label: "Struttura tecnica · Immagine 3", description: "Terza immagine della rotazione struttura tecnica Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaSupport", label: "Supporto aziendale · Immagine 1", description: "Prima immagine della rotazione supporto aziendale Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaSupportAlt1", label: "Supporto aziendale · Immagine 2", description: "Seconda immagine della rotazione supporto aziendale Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "meccatronicaSupportAlt2", label: "Supporto aziendale · Immagine 3", description: "Terza immagine della rotazione supporto aziendale Meccatronica.", section: "Contenuto", page: "Meccatronica", pageKey: "meccatronica" },
{ key: "gommistaHero", label: "Hero Gommista", description: "Hero principale della pagina Gommista.", section: "Hero", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaDetail", label: "Struttura gommista · Immagine 1", description: "Prima immagine della rotazione struttura Gommista.", section: "Contenuto", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaDetailAlt1", label: "Struttura gommista · Immagine 2", description: "Seconda immagine della rotazione struttura Gommista.", section: "Contenuto", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaDetailAlt2", label: "Struttura gommista · Immagine 3", description: "Terza immagine della rotazione struttura Gommista.", section: "Contenuto", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaSupport", label: "Supporto servizio gomme · Immagine 1", description: "Prima immagine della rotazione supporto servizio gomme.", section: "Contenuto", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaSupportAlt1", label: "Supporto servizio gomme · Immagine 2", description: "Seconda immagine della rotazione supporto servizio gomme.", section: "Contenuto", page: "Gommista", pageKey: "gommista" },
{ key: "gommistaSupportAlt2", label: "Supporto servizio gomme · Immagine 3", description: "Terza immagine della rotazione supporto servizio gomme.", section: "Contenuto", page: "Gommista", pageKey: "gommista" }
];

export const OPERATIONAL_ROTATION_SLOT_MAP = {
  lightDuty: ["lightDuty", "lightDutyAlt1", "lightDutyAlt2"],
  heavy: ["heavy", "heavyAlt1", "heavyAlt2"],
  mobileWorkshop: ["mobileWorkshop", "mobileWorkshopAlt1", "mobileWorkshopAlt2"],
  complex: ["complex", "complexAlt1", "complexAlt2"],
};

export const DIVISION_ROTATION_SLOT_MAP = {
  meccatronicaDetail: ["meccatronicaDetail", "meccatronicaDetailAlt1", "meccatronicaDetailAlt2"],
  meccatronicaSupport: ["meccatronicaSupport", "meccatronicaSupportAlt1", "meccatronicaSupportAlt2"],
  gommistaDetail: ["gommistaDetail", "gommistaDetailAlt1", "gommistaDetailAlt2"],
  gommistaSupport: ["gommistaSupport", "gommistaSupportAlt1", "gommistaSupportAlt2"],
};

export const FLEET_SLOT_KEYS = ["fleetCrane", "fleetTow", "fleetTruck", "fleetMobile"];

export const navItems = [
{ label: "Soccorso H24", href: "/", aliases: ["/soccorso-h24"], type: "route" },
{ label: "Meccatronica", href: "/meccatronica", type: "route" },
{ label: "Gommista", href: "/gommista", type: "route" },
{ label: "Contatti", href: "/contatti", type: "route" }];

export const SOCIAL_LINKS = [
{ key: "facebook", label: "Facebook", href: "https://www.facebook.com/viscarautoriparazioni" },
{ key: "instagram", label: "Instagram", href: "https://www.instagram.com/viscar_car_e_truck?igsh=aWVibnpuMmY0Nzd2" },
{ key: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@viscar2018?_r=1&_t=ZN-97G1t5TAqLG" },
];


export const services = [
{
  title: "Soccorso leggero",
  description: "Intervento rapido per auto, SUV, furgoni e veicoli commerciali leggeri su Messina, viabilità urbana e collegamenti autostradali.",
  bullets: ["Messina", "A18 / A20", "Van Support", "H24 Dispatch"],
  tag: "LIGHT DUTY"
},
{
  title: "Soccorso pesante",
  description: "Centrale operativa dedicata a camion, autobus, motrici, semirimorchi e mezzi industriali con recovery pesante su strada e autostrada.",
  bullets: ["Heavy Recovery", "Truck Support", "Mezzi pesanti", "A18 / A20"],
  tag: "HEAVY DUTY"
},
{
  title: "Officina mobile",
  description: "Officina mobile per cambio gomme autocarro, ripristini tecnici e supporto operativo quando il mezzo deve ripartire sul posto.",
  bullets: ["Mobile Unit", "Truck Support", "Road Service", "Ripartenza"],
  tag: "MOBILE UNIT"
},
{
  title: "Recuperi complessi",
  description: "Gestione H24 di incidenti, ribaltamenti, mezzi bloccati e recuperi tecnici con coordinamento operativo e mezzi attrezzati.",
  bullets: ["Recovery Team", "Crane Support", "Heavy Duty", "H24 Command"],
  tag: "RECOVERY TEAM"
}];


export const buildFleet = (imageSlots = DEFAULT_IMAGE_SLOTS, excludedImages = new Set()) => {
  const usedFleetImages = new Set();

  const getFleetImage = (slotKey) => {
    const candidate = imageSlots[slotKey];
    if (!candidate || excludedImages.has(candidate) || usedFleetImages.has(candidate)) return "";
    usedFleetImages.add(candidate);
    return candidate;
  };

  return [
    {
      name: "",
      category: "Heavy Recovery",
      description: "Mezzo operativo per recovery pesante, recuperi complessi, assistenza camion e supporto gru coordinato dalla centrale H24.",
      badges: ["Heavy Recovery", "Crane Support", "Mezzi pesanti", "H24 Dispatch"],
      image: getFleetImage("fleetCrane")
    },
    {
      name: "",
      category: "Road Assistance",
      description: "Mezzo dedicato al soccorso stradale leggero con risposta rapida su Messina, viabilità urbana e tratti autostradali principali.",
      badges: ["Road Assistance", "Rapid Response", "Messina", "A18 / A20"],
      image: getFleetImage("fleetTow")
    },
    {
      name: "",
      category: "Truck Support",
      description: "Supporto operativo per camion e veicoli da lavoro con copertura urbana, extraurbana e autostradale dalla base di Messina.",
      badges: ["Truck Support", "Road Service", "Tremestieri", "Autostrada"],
      image: getFleetImage("fleetTruck")
    },
    {
      name: "",
      category: "Mobile Unit",
      description: "Unità mobile per cambio gomme autocarro, piccole riparazioni e assistenza tecnica su strada per ridurre il fermo mezzo.",
      badges: ["Mobile Unit", "Truck Support", "Road Service", "H24 Support"],
      image: getFleetImage("fleetMobile")
    }
  ];
};


export const interventionCategoryOrder = [
{ key: "soccorso-leggero", label: "Soccorso leggero", description: "Interventi rapidi per auto, SUV e furgoni" },
{ key: "soccorso-pesante", label: "Soccorso pesante", description: "Recovery pesante per truck e semirimorchi" },
{ key: "officina-mobile", label: "Officina mobile", description: "Supporto tecnico e cambio gomme autocarro" },
{ key: "recupero", label: "Recuperi complessi", description: "Incidenti, ribaltamenti e mezzi bloccati" }
];

export const DEFAULT_INTERVENTION_PHOTOS = [];

export const getGalleryTag = (category) => {
if (category === "soccorso-leggero") return "Road Assistance";
if (category === "officina-mobile") return "Mobile Unit";
if (category === "soccorso-pesante") return "Heavy Recovery";
return "Recovery Team";
};